import { Autocomplete } from '@mui/material';
import { WidgetProps } from '@rjsf/utils';
import { TextField } from '../../../../ui/components/pure/text-field/text-field.component';

export function DynamicFormAutocomplete(props: WidgetProps) {
  return (
    <Autocomplete
      // Make the key dynamic based on whether the parent is set or not
      // This forces the component to re-render when the parent is set
      key={props.value ? `${props.name}-set` : `${props.name}-unset`}
      options={props.options.enumOptions ?? []}
      getOptionLabel={(option) => {
        if (typeof option === 'object') {
          return option.label;
        }
        return (
          ((props.options.enumOptions || []) as { label: string; value: string }[]).find((o) => o.value === option)
            ?.label || ''
        );
      }}
      isOptionEqualToValue={(option, value) => {
        if (typeof option === 'object') {
          return option.value === value;
        }
        return option === value;
      }}
      onChange={(_, selected) => props.onChange(selected?.value ?? '')}
      value={props.value}
      defaultValue={props.value}
      disabled={props.readonly}
      renderInput={(params) => (
        <TextField
          {...params}
          required={props.required}
          value={props.value}
          textFieldVariant="floating"
          placeholder={props.label}
          disabled={props.readonly}
          style={{
            width: '100%'
          }}
        />
      )}
      style={{
        width: '100%'
      }}
    />
  );
}
